import type { FilterOptions, ICaseItemDetailedReq, IInventoryItemDetailedWithTranslateReq } from '@dev-fast/types';

export class GetFullSkinData {
  static readonly type = '[Skins] Get full data';

  constructor(public params: ICaseItemDetailedReq) {}
}

export class GetCaseItemDetailsWithTranslate {
  static readonly type = '[Skins] Get item details with translate';

  constructor(public params: IInventoryItemDetailedWithTranslateReq) {}
}

export class GetAvailabilityItemInCases {
  static readonly type = '[Skins] Get item availability in cases';

  constructor(public params: { name?: string; shortName?: string; skin?: string }) {}
}

export class GetItemAvailabilityOnThenMarket {
  static readonly type = '[Skins] Get item availability in market';

  constructor(public params: Partial<FilterOptions>) {}
}

export class SetItemDetailsLoadingStatus {
  static readonly type = '[Skins] Set Item Details Loading Status';

  constructor(public isLoadingItemDetails: boolean) {}
}
